import React, { useState } from "react";
import { FiPlus, FiX } from "react-icons/fi";
import { assets } from "../../../Assets/assets";

const data = [
  {
    id: "01",
    q: "What is QQT and its role in international trade?",
    a: "QQT stands for Quick Quotations and Trade. It is a web-based commodity trading platform (website, android & IOS app) from PCM Exports. This app is designed to provide quick quotations of a product from multiple suppliers across India and facilitate international trade.",
  },
  {
    id: "02",
    q: "Why would someone use the QQT platform?",
    a: "It is a fast-paced secured trade platform, especially designed for export and domestic bulk trade, where buyers can get the lowest price quotation for any product in India and follow step-by-step trade procedure for quick and flawless trade facilitation.",
  },
  {
    id: "03",
    q: "How to become a buyer / supplier on QQT platform?",
    a: "Download QQT App from Google Play Store or Apple App Store or you can register as a buyer from www.pcmexports.com website as well. You can register your company as a buyer or supplier or both with the same mobile number and GST number.",
  },
  {
    id: "04",
    q: "What is the role of AI in the QQT process.",
    a: [
      "QQT is a tech-enabled platform that uses Artificial Intelligence for multi-vendor comparative quotation analysis and automatic ranking of quotations based on multiple parameters set by the buyer for his requirement.",
      "For example it analyses moisture, count, foreign matter content, price etc. and ranks the best matching quotation at the top followed by other quotations based on % of matching criteria.",
    ],
  },
  {
    id: "05",
    q: "What products does QQT deal with?",
    a: "It deals with multiple categories of products like Grains, Pulses, Spices, Dry Fruits, Millets, Herbs, Goshala Products, Packaged Food Products, Organic Agro Products, Fresh Fruits, Fresh Vegetables, Fruit Powders, Vegetable Powders, Certified Organic Products, Corporate Gift Packs (Empty Gift Boxes / Packs), Dry Fruit Gift Packs etc.",
  },
  {
    id: "06",
    q: "Summarize the QQT process:",
    a: [
      "The Trade on QQT platform can be summarized into the following major steps:",
      "1.Buyer selects a product and provides price and other details (sample photo & video, product quality parameters, expected price range etc.)",
      "2.Buyer provides a platform fee and submits his requirement.",
      "3.QQT admin reviews the purchase requirement and sends it to all linked suppliers.",
      "4.QQT admin collects quotations from all linked suppliers and AI ranks them together showing best matching quotations at the top.",
      "5.QQT admin sends top 3 quotations to the buyer and buyer can ask for samples to 1 or 2 or all 3 quotations.",
      "6.Buyer will pay the sample cost and courier charges and wait for samples to arrive.",
      "7.PCM Exports will send an Order Fulfilment Manager (OFM) to visit supplier premise to check if he is having sufficient stock at his godown to fulfil the buyer’s order.",
      "8.The OFM will check the quality parameters provided by the buyer and ensure the stock is qualifying the quality tests.",
      "9.	After OFM approval, the courier partner will pick up the sample from the supplier’s premise and send it directly to the buyer’s premise.",
      "10.	Note: PCM Exports doesn’t verify the quality of the product and only buyer has to check the quality of the product and declare if it is suitable for making a full order or not.",
      "11.	Buyer finalizes the best sample and makes payment for the final order (on PCM Exports escrow account or by making an Irrevocable Letter of Credit).",
      "12. OFM visits the supplier premise again with the sample and ensures the sample provided to buyer matches with the final stock to be sent to him.",
      "13.	Supplier raises a GST invoice in the name of PCM Exports and PCM Exports raises a GST invoice in the name of the buyer.",
      "14.	PCM Exports sends the transporter to transport the material from the supplier’s location to the buyer’s location.",
      "15.	Buyer receives the material and gives clarification if the final stock received matches with the sample provided or not.",
      "16.	In case buyer declares a full match, then he has to release the funds in the escrow account or ILC.",
      "17.	In case of full or partial mismatch, the OFM will visit buyer’s premise and validate the claim of the buyer. If it is found that buyer’s claim is correct, the material will be sent to the seller (in TO PAY mode).",
      "18.	In this case buyer can order another sample or close the deal and get refund for the payment made by him.",
    ],
  },
  {
    id: "07",
    q: "How will the payment procedure work in QQT?",
    a: "The platform fee and final payment can be made through multiple payment gateways provided on the QQT platform. Apart from direct transfers, a buyer or seller can also pay manually through RTGS  / IMPS system of Internet Banking. No cheque is accepted in this platform.",
  },
  {
    id: "08",
    q: "If the entire transaction can be done manually then why would a buyer/supplier go through the QQT app procedure?",
    a: [
      "The traditional manual trading procedure has many loopholes due to which even many experienced traders and manufactures loose either valuable time or money or both. So, this platform is made after 10 years of research and all necessary compliance steps are included in this process to make the trades safer and quicker.",
      "Since there are multiple digital footprints, checks and balances available on the QQT platform to safeguard the interests of the Buyer and the Seller, this platform is really a boon for both the parties.",
    ],
  },
  {
    id: "09",
    q: "Who can be a Buyer on the QQT platform?",
    a: "Any party having a valid GST licence can be a buyer. It can be an international buyer or a domestic buyer like quick-commerce platforms, corporates, hotels, event management companies, traders, corporate houses who needs gift packs for their employees, wholesalers, manufacturers requiring raw materials etc.",
  },
  {
    id: "10",
    q: "Who can be a seller on QQT platform?",
    a: "Big farmers, aggregators, manufacturers, importers, traders, wholesalers etc. can become.",
  },
  {
    id: "11",
    q: "What is the benefits of a supplier getting onboarded on the QQT platform?",
    a: "There is no annual fee for the suppliers or buyers. A supplier gets some rupees reward for each quotation he gives on QQT platform. The reward is credited to his QQT wallet which he can use for getting a purchase quotation. The supplier does not provide any commission what so ever to PCM Exports.",
  },
  {
    id: "12",
    q: "What if the final goods don’t match the sample?",
    a: "If the final order material doesn’t match with the sample provided, OFM has to verify it and if it is found that the buyer’s claim is correct, then the supplier has to take back the materials at his expense. Otherwise the buyer is bound to keep the material and make the payment.",
  },
  {
    id: "13",
    q: "What is the designated account for the buyer's payment, and what is the payment timeline following the finalization of the deal?",
    a: "The buyer makes payment to PCM Exports Current A/c linked Escrow Account or draws an Irrevocable Letter of Credit in the name of PCM Exports. Once buyer approves the quality of the material and the amount gets credited to PCM Exports A/c, the supplier gets it credited in its account within 24 hours.",
  },
  {
    id: "14",
    q: "Why will payments be sent to PCM Exports company account?",
    a: "PCM Exports acts as the moderator and platform service provider. It acts as the custodian of the trade deal.",
  },
  {
    id: "15",
    q: "What is the benefits of a supplier getting onboarded on the QQT platform?",
    a: "There is no annual fee for the suppliers or buyers. A supplier gets some rupees reward for each quotation he gives on QQT platform. The reward is credited to his QQT wallet which he can use for getting a purchase quotation. The supplier does not provide any commission what so ever to PCM Exports.",
  },
];

const Qna = () => {
  const [active, setActive] = useState(null);

  const toggle = (id) => {
    setActive(active === id ? null : id);
  };

  return (
    <div className="relative w-full pt-6 pb-14 sm:py-16 px-4 md:px-8 overflow-hidden">
      {/* FLOATING QUESTION MARKS */}
      {/* Top Header Region */}
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "0s" }}
        className="absolute left-[60%] top-3 w-16 animate-float pointer-events-none select-none opacity-85"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "0.6s" }}
        className="absolute left-[34%] top-2 w-10 animate-float-slow pointer-events-none select-none opacity-60"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "1.2s" }}
        className="absolute right-[36%] top-5 w-12 animate-float-sway pointer-events-none select-none opacity-65"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "1.8s" }}
        className="absolute left-[18%] top-6 w-14 animate-float-reverse pointer-events-none select-none opacity-70"
      />

      {/* Upper Sides */}
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "0.4s" }}
        className="absolute left-[5%] top-[5%] w-24 animate-float pointer-events-none select-none opacity-80"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "1.5s" }}
        className="absolute left-[12%] top-[18%] w-10 animate-float-sway pointer-events-none select-none opacity-55"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "0.2s" }}
        className="absolute right-[20%] top-32 w-14 animate-float-slow pointer-events-none select-none opacity-80"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "0.9s" }}
        className="absolute right-[10%] top-40 w-36 animate-float pointer-events-none select-none opacity-75"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "2.1s" }}
        className="absolute right-[3%] top-[14%] w-16 animate-float-reverse pointer-events-none select-none opacity-60"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "1.1s" }}
        className="absolute right-[28%] top-[12%] w-8 animate-float-sway pointer-events-none select-none opacity-50"
      />

      {/* Mid Left & Right Margins */}
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "1s" }}
        className="absolute left-[0%] bottom-36 w-40 animate-float-slow pointer-events-none select-none opacity-70"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "2.4s" }}
        className="absolute left-[3%] top-[42%] w-14 animate-float-reverse pointer-events-none select-none opacity-60"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "0.8s" }}
        className="absolute left-[1%] top-[58%] w-20 animate-float-sway pointer-events-none select-none opacity-55"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "1.7s" }}
        className="absolute right-[2%] top-[52%] w-24 animate-float-sway pointer-events-none select-none opacity-65"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "2.8s" }}
        className="absolute right-[11%] top-[62%] w-14 animate-float-slow pointer-events-none select-none opacity-70"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "0.5s" }}
        className="absolute right-[5%] top-[72%] w-16 animate-float-reverse pointer-events-none select-none opacity-60"
      />

      {/* ── MIDDLE & INNER SCATTERED FLOATING MARKS ── */}
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "0.3s" }}
        className="absolute left-[28%] top-[10%] w-12 animate-float-pulse pointer-events-none select-none opacity-65 rotate-12"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "1.6s" }}
        className="absolute left-[46%] top-[12%] w-14 animate-float-spin pointer-events-none select-none opacity-50"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "2.3s" }}
        className="absolute left-[68%] top-[15%] w-10 animate-float-sway pointer-events-none select-none opacity-60 -rotate-12"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "0.7s" }}
        className="absolute left-[24%] top-[22%] w-16 animate-float-slow pointer-events-none select-none opacity-45 rotate-6"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "1.9s" }}
        className="absolute left-[54%] top-[25%] w-20 animate-float-reverse pointer-events-none select-none opacity-40 -rotate-12"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "3.1s" }}
        className="absolute left-[36%] top-[32%] w-14 animate-float-pulse pointer-events-none select-none opacity-50 rotate-45"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "1.4s" }}
        className="absolute left-[72%] top-[34%] w-16 animate-float-spin pointer-events-none select-none opacity-55"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "0.5s" }}
        className="absolute left-[44%] top-[40%] w-24 animate-float-slow pointer-events-none select-none opacity-35 -rotate-6"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "2.7s" }}
        className="absolute left-[26%] top-[46%] w-14 animate-float-sway pointer-events-none select-none opacity-45 rotate-12"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "1.1s" }}
        className="absolute left-[62%] top-[48%] w-18 animate-float-reverse pointer-events-none select-none opacity-50 rotate-6"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "3.4s" }}
        className="absolute left-[34%] top-[55%] w-12 animate-float-pulse pointer-events-none select-none opacity-55 -rotate-45"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "2.1s" }}
        className="absolute left-[52%] top-[58%] w-20 animate-float-sway pointer-events-none select-none opacity-40 rotate-12"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "0.8s" }}
        className="absolute left-[70%] top-[62%] w-14 animate-float-spin pointer-events-none select-none opacity-50"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "1.7s" }}
        className="absolute left-[28%] top-[68%] w-16 animate-float-slow pointer-events-none select-none opacity-45 -rotate-12"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "3.2s" }}
        className="absolute left-[48%] top-[72%] w-14 animate-float-pulse pointer-events-none select-none opacity-55 rotate-6"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "2.5s" }}
        className="absolute left-[64%] top-[76%] w-12 animate-float-reverse pointer-events-none select-none opacity-50 -rotate-12"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "1.3s" }}
        className="absolute left-[36%] top-[82%] w-18 animate-float-sway pointer-events-none select-none opacity-45 rotate-12"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "2.9s" }}
        className="absolute left-[54%] top-[86%] w-14 animate-float-spin pointer-events-none select-none opacity-55"
      />

      {/* Bottom Region */}
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "1s" }}
        className="absolute left-[10%] bottom-10 w-16 animate-float pointer-events-none select-none opacity-80"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "2.2s" }}
        className="absolute left-[5%] bottom-28 w-12 animate-float-sway pointer-events-none select-none opacity-60"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "1.3s" }}
        className="absolute left-[16%] bottom-4 w-10 animate-float-slow pointer-events-none select-none opacity-50"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "0.5s" }}
        className="absolute right-[10%] bottom-20 w-24 animate-float-slow pointer-events-none select-none opacity-75"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "0.7s" }}
        className="absolute right-[4%] hidden sm:block bottom-10 w-12 animate-float-reverse pointer-events-none select-none opacity-80"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "1.9s" }}
        className="absolute right-[18%] bottom-6 w-16 animate-float-sway pointer-events-none select-none opacity-60"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "2.5s" }}
        className="absolute left-[48%] bottom-6 hidden sm:block w-12 animate-float-slow pointer-events-none select-none opacity-45"
      />

      {/* Ambient Large Background Marks */}
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "1s" }}
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 hidden md:block w-72 lg:w-96 animate-float-slow pointer-events-none select-none opacity-10 z-0"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "2s" }}
        className="absolute left-[20%] top-[38%] hidden lg:block w-48 animate-float-reverse pointer-events-none select-none opacity-10 z-0"
      />
      <img
        alt="vector"
        src={assets.qnavector}
        style={{ animationDelay: "3s" }}
        className="absolute right-[22%] top-[42%] hidden lg:block w-52 animate-float-sway pointer-events-none select-none opacity-10 z-0"
      />

      <div className="max-w-3xl mx-auto relative z-10">
        {/* TITLE */}
        <h2 className="text-center text-2xl md:text-4xl xl:text-5xl font-semibold text-primaryTextColor mb-6 md:mb-10">
          Frequently asked Questions
        </h2>

        {/* LIST */}
        <div className="flex flex-col gap-4">
          {data.map((item) => {
            const isOpen = active === item.id;

            return (
              <div
                key={item.id}
                className={`rounded-xl border transition-all duration-300 
                  ${isOpen
                    ? "border-primaryColor bg-red-50 shadow-sm"
                    : "border-gray-200 bg-white"
                  }
                `}
              >
                {/* HEADER */}
                <div
                  onClick={() => toggle(item.id)}
                  className="flex items-center justify-between p-4 cursor-pointer"
                >
                  <div className="flex items-center gap-4">
                    {/* NUMBER */}
                    <div className="w-10 h-10 shrink-0 rounded-full bg-gray-100 flex items-center justify-center text-sm font-medium text-gray-600">
                      {item.id}
                    </div>

                    {/* QUESTION */}
                    <p className="text-sm md:text-base text-primaryTextColor font-medium">
                      {item.q}
                    </p>
                  </div>

                  {/* ICON */}
                  <div className="text-primaryColor">
                    {isOpen ? <FiX /> : <FiPlus />}
                  </div>
                </div>

                {/* ANSWER */}
                <div
                  className={`px-4 overflow-hidden transition-all duration-300 ease-in-out
                  ${isOpen ? "max-h-[1000px] pb-4 opacity-100" : "max-h-0 opacity-0"}
                  `}
                >
                  <div className="text-sm text-gray-500 leading-relaxed ml-14 space-y-2">
                    {Array.isArray(item.a) ? (
                      item.a.map((paragraph, index) => (
                        <p key={index}>{paragraph}</p>
                      ))
                    ) : (
                      <p>{item.a}</p>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Qna;
